import React, { FC } from 'react'

import { Blok } from '@app/typings/blok'
import { useCloseOverlaysOnRouteChange } from '@app/hooks/use-close-overlays-on-route-change'
import { StoryblokComponent } from '@storyblok/react'
import { getBlokContent } from '@app/utils/blok-content'

type Props = {
  body: Blok[]
}

export const revalidate = 60 * 15 // revalidate this page every 15 minutes

export const Page: FC<Props> = (props) => {
  useCloseOverlaysOnRouteChange()

  return (
    <div>
      {props.body?.map((content) => (
        <StoryblokComponent key={content._uid} blok={getBlokContent([content])} {...getBlokContent([content])} />
      ))}
    </div>
  )
}
